/* import __COLOCATED_TEMPLATE__ from './error-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();